import DocumentCard from "./DocumentCard";
import DocumentRequeteCard from "./DocumentRequeteCard";
import DocumentSpan from "./DocumentSpan";
import DocumentDialog from "./DocumentDialog";
import SupprimeDocumentDialog from "./SupprimeDocumentDialog";
import SousTypeDocumentSwitch from "./SousTypeDocumentSwitch"

export default {
    install(Vue) {
        Vue.component("a-document-card", DocumentCard);
        Vue.component("a-document-requete-card", DocumentRequeteCard);
        Vue.component("a-document-span", DocumentSpan);
        Vue.component("a-document-dialog", DocumentDialog);
        Vue.component("a-supprime-document-dialog", SupprimeDocumentDialog);
        Vue.component("a-sous-type-document-switch", SousTypeDocumentSwitch);
    }
}
